import { Tooltip } from '@chakra-ui/tooltip';
import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { IFileMetaData } from '@publishing-engine/domain/models';
import React from 'react';
import { downloadFile } from 'src/utils/file';
type DownloadFileProps = {
  file: IFileMetaData | null;
};
export const DownloadFile: React.FC<DownloadFileProps> = ({ file }) => {
  if (file === null) {
    return null;
  }
  const DownloadFileHandle = () => {
    if (!file.url) {
      return;
    }
    downloadFile(file?.url);
  };
  return (
    <Tooltip
      hasArrow
      shouldWrapChildren
      placement="top"
      label={`Download File : ${file?.name}`}
      borderRadius={4}
      data-cy="info-tooltip"
    >
      <ButtonText onClick={DownloadFileHandle}>
        <FontAwesomeIcon fontStyle="textContext" icon={faArrowDownToBracket} />
      </ButtonText>
    </Tooltip>
  );
};
